<template>
    <div>
        <label
            v-if="label"
            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            :for="id"
        >
            {{ label }}
            <span v-if="required" class="text-red-500">*</span>
        </label>

        <div
            class="flex flex-no-wrap"
            :class="{ 'border-red-400': errors.length, 'border border-grey-200 rounded focus:shadow-outline-xs focus:border-blue-400' : !readonly, 'outline-none pt-1': readonly }"
        >
            <span class="bg-gray-300 p-3" v-if="prefix">{{ prefix }}</span>
            <input
                ref="input"
                class="w-full"
                :class="{'p-3': !readonly}"
                v-bind="$attrs"
                :readonly="readonly"
                :id="id"
                :type="type"
                :value="value"
                :required="required"
                @input="$emit('input', $event.target.value)"
            />
            <span @click="clear()" class="bg-gray-300 p-3" v-if="prefix">x</span>
        </div>
        <div v-if="errors.length" class="text-red-500 text-sm mt-2">{{ errors[0] }}</div>

        <div v-if="help" class="text-sm text-gray-600 py-2">{{ help }}</div>
    </div>
</template>

<script>
    export default {
        inheritAttrs: false,
        props: {
            id: {
                type: String,
                default() {
                    return `text-input-${this._uid}`;
                }
            },
            readonly: {
                type: Boolean,
                default: false
            },
            type: {
                type: String,
                default: "text"
            },
            prefix: {
                type: String,
                default: ''
            },
            value: null,
            required: {
                type: Boolean,
                default: false
            },
            label: String,
            errors: {
                type: Array,
                default: () => []
            },
            help: String
        },
        methods: {
            focus() {
                this.$refs.input.focus();
            },
            select() {
                this.$refs.input.select();
            },
            setSelectionRange(start, end) {
                this.$refs.input.setSelectionRange(start, end);
            },
            clear(){
                this.$refs.input.attr('value','');
            }
        }
    };
</script>
